/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_TitleInputs */

const vi_customer_title = /** @type {(inputs: Customer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng`)
};

/**

* @param {Customer_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_title = /** @type {((inputs?: Customer_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_title(inputs)
});